import React from 'react'
import moment from 'moment'
import { useCourseStore } from '../store/CourseStore'

const LeaderboardView = ({ sortedRounds, isFinalized, eventDate }) => {
  const course = useCourseStore((state) => state.course)

  return (
    <div>
      <table cellPadding={0} cellSpacing={0}>
        <thead style={{ top: '60px', position: 'sticky' }}>
          <tr style={{ backgroundColor: '#676767', color: '#fff' }}>
            <HeaderTD content={`${eventDate ? moment(eventDate).format('M/D/YY') + ' - ' : ''}${course.courseName}`} align="left" />
            <HoleNumbers course={course} />
            <HeaderTD content="Out" />
            <LBHead content="Hcp" />
            <LBHead content="Net" />
            <HeaderTD content="+/-" />
            {isFinalized && <HeaderTD content="Pts" />}
            <HeaderTD content=" " />
          </tr>
          <tr className="landscape-only" style={{ backgroundColor: '#898989', color: '#fff' }}>
            <HeaderTD content="Par" align="left" />
            <HolePars course={course} />
            <CoursePar course={course} />
            <HeaderTD content="" />
            <HeaderTD content="" />
            <HeaderTD content="" />
            {isFinalized && <HeaderTD content="" />}
            <HeaderTD content="" />
          </tr>
        </thead>
        <tbody>
          {sortedRounds?.map((round, i) => (
            <RoundTR key={i} round={round} index={i} course={course} isFinalized={isFinalized} />
          ))}
        </tbody>
      </table>
      <div className="portrait-only" style={{ textAlign: 'center', padding: '8px' }}>
        Rotate for full leaderboard
      </div>
    </div>
  )
}

const RoundTR = ({ round, index, course, isFinalized }) => {
  return (
    <tr key={round.roundId} style={index % 2 === 0 ? { backgroundColor: '#efefef' } : {}}>
      <td className="golferLBName leaderboard-names" style={{ padding: '4px' }}>
        {round.golferName}
      </td>
      <HoleDivs round={round} course={course} styleClass={'landscape-only'} />
      <LBData content={round.grossScore} />
      <LBData content={round.golferHcp} styleClass={'landscape-only hcpGray'} />
      <LBData content={round.netScore} styleClass={'landscape-only'} />
      <LBScoreToPar scoreToPar={round.scoreToPar} />
      {isFinalized && <td className="golferLBName" align="center" style={{ padding: '10px 15px', color: '#2f855a', fontWeight: 'bold' }}>{round.points}</td>}
      <LBNetScore thru={round.thru} netScore={round.netScore} />
    </tr>
  )
}

const LBNetScore = ({ thru, netScore }) => {
  if (thru < 9) {
    return <LBData content={`#${thru < 1 ? 1 : thru}`} styleClass={'LBincomplete'} />
  } else {
    return <LBData content={netScore} styleClass={'blackBold'} />
  }
}

const LBData = ({ content, styleClass }) => {
  return (
    <td className={`golferLBName ${styleClass || ''}`} align="center" style={{ padding: '10px 15px' }}>
      {content}
    </td>
  )
}

const LBScore = ({ content, styleClass }) => {
  return (
    <td className={`lbScore landscape-only`} align="center" style={{ padding: '4px' }}>
      <div className={styleClass}>{content}</div>
    </td>
  )
}

const LBScoreToPar = ({ scoreToPar }) => {
  if (scoreToPar === 0) {
    return <LBData content={`E`} styleClass={'blackBold'} />
  } else if (scoreToPar < 0) {
    return <LBData content={`${scoreToPar}`} styleClass={'blackBold'} />
  } else {
    return <LBData content={`+${scoreToPar}`} styleClass={'blackBold'} />
  }
}

const LBHead = ({ content, styleClass }) => {
  return (
    <td className={`golferLBHead landscape-only`} align="center" style={{ padding: '1px 16px' }}>
      <div className={styleClass}>{content}</div>
    </td>
  )
}

const HoleDivs = ({ round, course }) => {
  let holes = course?.courseHoles
  let holeScores = []
  let scoreStyle = []
  let i = 0

  for (const key in round.holeScores) {
    holeScores.push(round.holeScores[key].holeScore)
    let net = round.holeScores[key].holeScore - holes[i].holePar

    if (net < -1) scoreStyle[i] = 'LBscore LBeagle'
    else if (net < 0) scoreStyle[i] = 'LBscore LBbirdie'
    else if (net < 1) scoreStyle[i] = 'LBscore'
    else if (net < 2) scoreStyle[i] = 'LBscore LBbogey'
    else scoreStyle[i] = 'LBscore LBdbogey'

    i++
  }

  return (
    <React.Fragment>
      {holeScores.map((score, i) => (
        <LBScore
          key={`${i}-${score}`}
          content={score > 0 ? score : ''}
          styleClass={`landscape-only ${score > 0 ? scoreStyle[i] : ''}`}
        />
      ))}
    </React.Fragment>
  )
}

const HeaderTD = ({ content, align }) => {
  return (
    <td align={align || 'center'} className="golferLBHead leaderboard-names" style={{ padding: '2px 10px' }}>
      {content}
    </td>
  )
}

const HoleNumbers = ({ course }) => {
  return (
    <React.Fragment>
      {course?.courseHoles?.map((h) => (
        <LBHead key={`${h.holeNum}-${h.holeNum}`} content={h.holeNum} styleClass="landscape-only" />
      ))}
    </React.Fragment>
  )
}

const HolePars = ({ course }) => {
  return (
    <React.Fragment>
      {course?.courseHoles?.map((h) => (
        <LBHead key={`${h.holeNum}-${h.holePar}`} content={h.holePar} styleClass="landscape-only" />
      ))}
    </React.Fragment>
  )
}

const CoursePar = ({ course }) => {
  let par = 0
  course?.courseHoles?.map((h) => {
    par += h.holePar
  })

  return (
    <React.Fragment>
      <LBHead key={`coursepar-${par}`} content={par} styleClass="landscape-only" />
    </React.Fragment>
  )
}
export default LeaderboardView
